/**
 * Charts Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import TrackList from '../../search/TrackList';
import SectionTitle from '../SectionTitle';

interface IChartsProps {
  itemBackgroundColor?: Color;
  data: GQL.IHomePageTrackChartList[];
}

interface IChartProps {
  data: GQL.IHomePageTrackChartList;
  backgroundColor?: Color;
}

const chartsClasses = new BEM('charts');
const chartClasses = new BEM('chart');

function Chart({ backgroundColor = 'bw3', data }: IChartProps) {
  return (
    <>
      <SectionTitle title={data.name!} subtitle="Best of" {...chartClasses('title')} />
      <TrackList
        cardProps={{
          backgroundColor,
          size: 'small',
        }}
        displayPriceElement={false}
        tracks={data.items!}
        {...chartClasses('item')}
      />
    </>
  );
}

export default function Charts({ itemBackgroundColor, data }: IChartsProps) {
  const hasValidCharts = data.some(({ items }) => !!items && !!items.length);
  return hasValidCharts ? (
    <div {...chartsClasses()}>
      <div {...chartsClasses('content-wrapper', '', 'container')}>
        {data.map((chart, index) => !!chart.items && !!chart.items.length && (
          <div key={`chart-${index}`} {...chartClasses()}>
            <Chart data={chart} backgroundColor={itemBackgroundColor} />
          </div>
        ))}
      </div>
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/Charts/index.tsx